export default __webpack_public_path__ + "static/media/Steelers.1e4bdfa1.svg";